import { ReturnRule } from '../../types/order-merchant';
import { ReturnItem } from '../../types/order';

export default function getItemsWithMatchingRules(
  itemsForReturn: Array<ReturnItem>,
  merchantRules: Array<ReturnRule>
): Array<{ item: ReturnItem; rule: ReturnRule }> {
  return itemsForReturn.reduce((items, item) => {
    const rule = merchantRules.find(
      r =>
        r.condition_id === item.returnDetails?.condition &&
        r.reason_id === item.returnDetails?.reason
    );
    return rule !== undefined ? [...items, { item, rule }] : items;
  }, [] as Array<{ item: ReturnItem; rule: ReturnRule }>);
}
